module.exports = __webpack_public_path__ + "img/Patch9-1.008595fb.webp";